const SPECIAL = { 'about-us': '/about', 'for-organisations': '/for-organisations' };

export const publicPagePath = (slug) => SPECIAL[slug] || `/page/${slug}`;

export const cmsNavLinks = (pages) => pages.map((p) => ({ label: p.nav_label || p.title, url: publicPagePath(p.slug) }));
